"use client";

import { useQueryClient } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { useGraphqlMutation } from "@/lib/graphql/useGraphql";

type ReconcileBillingData = {
  reconcileBilling: boolean;
};

const reconcileBillingDocument = gql`
  mutation ReconcileBilling {
    reconcileBilling
  }
`;

export const useReconcileBilling = () => {
  const queryClient = useQueryClient();

  return useGraphqlMutation<ReconcileBillingData, Record<string, never>>({
    mutationKey: ["reconcile-billing"],
    document: reconcileBillingDocument,
    onSuccess: () => {
      // Refresh the billing overview so the reconcile button disappears and
      // payment methods reflect the updated state.
      void queryClient.invalidateQueries({ queryKey: ["billing-overview"] });
      // Also refresh the session so billing_complete is up-to-date in the
      // nav/gating logic.
      void queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
};
